const environment = "test";

export const geoCodeMain =
  "The API series provides endpoints to retrieve details about various locations such as airports, train stations, and hotels. Based on the type of input provided, the API returns information including the name, latitude, longitude, and address (if necessary) of the requested place.";

export const geoCodePickup = {
  intro: `This API provides geocode information (latitude and longitude) along with the address details of places based on the type specified in the query parameters for pickups. The places can include hotels, airports, and train stations.`,

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/apisearchPlacesByName`
      : `https://api.drivado.com/api/v1/api/apisearchPlacesByName`,

  responseDes: `On a successful request, the API returns the latitude and longitude
            of the place searched for, which can be used for further references.`,
};

export const geoCodeDropoff = {
  intro: `This API provides geocode information (latitude and longitude) along with the address details of places based on the type specified in the query parameters for dropoff. The places can include hotels, airports, and train stations.`,

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/apisearchPlacesByName`
      : `https://api.drivado.com/api/v1/api/apisearchPlacesByName`,

  responseDes: `On a successful request, the API returns the latitude and longitude
            of the place searched for, which can be used for further references.`,
};
